import { useEffect, useRef, useState } from "react";
import { GoArrowRight } from "react-icons/go";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BannerImage from "../../assets/png/banner_img (2).png";
import { getBanners } from "../../redux/slices/banner/bannerSlice";
import { dispatch } from "../../redux/store";

const BannerOne = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const buttonRef = useRef<HTMLDivElement>(null);
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();

  const { banners, isLoading, error } = useSelector(
    (state: any) => state.banner
  );

  useEffect(() => {
    dispatch(getBanners());
  }, [dispatch]);

  useEffect(() => {
    buttonRef.current?.addEventListener("mouseenter", () => setHover(true));
    buttonRef.current?.addEventListener("mouseleave", () => setHover(false));
  });

  useEffect(() => {
    const timer = setInterval(() => {
      if (banners && banners.length + 1 > 0) {
        setCurrentSlide((prev) => (prev + 1) % (banners.length + 1));
      }
    }, 7000);

    return () => clearInterval(timer);
  }, [banners]);

  if (isLoading)
    return (
      <div className="w-full px-3 relative rounded-md overflow- flex flex-col gap-3 md:gap-0 items-center md:mb-20">
        <div className="grid animate-pulse grid-cols-9 cursor-pointer overflow-hidden w-full bg-slate-300 aspect-[19/10]"></div>
      </div>
    );
  const bannerContent = {
    title: "Fresh & Healthy Organic Food",
    subtitle: "Sourced locally for the freshest, healthiest produce.",
    image: BannerImage,
  };

  // Function to get the current banner (either hardcoded or from backend)
  const getCurrentBanner = () => {
    if (currentSlide === 0) return bannerContent;
    return banners[currentSlide - 1] || bannerContent;
  };

  const currentBanner = getCurrentBanner();
  const handleBannerClick = (id: number) => {
    navigate(`/products?promoId=${id}`);
  };
  return (
    <div className="w-full px-3 relative rounded-md overflow- flex flex-col gap-3 md:gap-0 items-center md:mb-20">
      <div
        className="grid grid-cols-9 cursor-pointer overflow-hidden w-full bg-[#EDF2EE] aspect-[19/10]"
        style={{
          position: "relative",
          backgroundImage:
            currentSlide === 0
              ? "none"
              : `url(${
                  currentBanner.imageUrl ||
                  currentBanner.image ||
                  "/placeholder-image.png"
                })`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundBlendMode: currentSlide === 0 ? "normal" : "",
        }}
        onClick={() => {
          if (currentSlide !== 0) handleBannerClick(currentBanner.id);
        }}
      >
        {[...banners, {}]?.length > 1 && (
          <>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setCurrentSlide(
                  (prev) =>
                    (prev - 1 + (banners?.length + 1 || 1)) %
                    (banners?.length + 1 || 1)
                );
              }}
              className="absolute transition-all cursor-pointer left-2 md:left-4 top-1/2 transform -translate-y-1/2 hover:bg-white/80 p-2 rounded-full shadow-custom z-20"
              aria-label="Previous slide"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-3 h-3 lg:w-6 lg:h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 19.5L8.25 12l7.5-7.5"
                />
              </svg>
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                setCurrentSlide(
                  (prev) => (prev + 1) % (banners?.length + 1 || 1)
                );
              }}
              className="absolute right-2 md:right-4 cursor-pointer top-1/2 transform -translate-y-1/2 hover:bg-white/80 p-2 rounded-full shadow-custom transition-colors z-20"
              aria-label="Next slide"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-3 h-3 lg:w-6 lg:h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                />
              </svg>
            </button>
          </>
        )}
        <div className="col-span-9 md:col-span-5 flex flex-col justify-center z-10">
          {currentSlide === 0 && (
            <div className="w-full text-center pl-7 lg:pl-20">
              <div className="font-[poppins] font-[600] text-[20px] lg:text-[40px] xl:text-[72px] text-start text-black transition-all duration-500">
                Fresh & Healthy
                <br /> Organic Food
              </div>
              <div className="flex gap-2 font-[poppins] text-[12px] md:text-[22px] xl:text-[32px] text-start text-black mt-[15px] md:mt-[35px] transition-all duration-500">
                Sale up to{" "}
                <div className="text-[#FF8A00] font-semibold">30% OFF</div>
              </div>
              <div className="text-start font-[poppins] text-[10px] md:text-md">
                Free shipping on all your order. we deliver, you enjoy
              </div>
              <div className="font-[poppins] font-normal text-[32px] text-start text-black mt-4 lg:mt-[35px]">
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate("/products");
                  }}
                  ref={buttonRef}
                  className="bg-[#05A30D] hover:opacity-70 cursor-pointer transition-all hover:scale-105 font-semibold items-center flex gap-4 py-1 md:py-4 w-fit text-white rounded-full text-[12px] md:text-[16px] px-[28px]"
                >
                  Shop Now{" "}
                  <GoArrowRight
                    className={`transition-all size-4 md:size-6 ${
                      hover && "translate-x-2"
                    }`}
                  />
                </span>
              </div>
            </div>
          )}
        </div>

        {currentSlide === 0 && (
          <div className="col-span-4 hidden md:flex items-end justify-center object-contain place-self-center">
            <img
              src={bannerContent.image}
              alt="Banner"
              className="w-full object-contain transition-opacity duration-500"
            />
          </div>
        )}
      </div>

      {/* Slide indicators */}
      <div className="md:absolute w-full flex justify-center md:w-fit mx-auto bottom-4 md:bottom-20 md:left-1/2 transform md:-translate-x-1/2 space-x-2 z-20">
        {banners &&
          [...banners, {}]?.map((_: any, index: number) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-2 rounded-full transition-all duration-300 ${
                currentSlide === index
                  ? "w-6 bg-[#067D23]"
                  : "w-2 bg-gray-300 hover:bg-gray-400"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
      </div>
    </div>
  );
};

export default BannerOne;
